export const ADD_NEW_USER_ONBOARDING = 'ADD_NEW_USER_ONBOARDING'
export const SET_NEW_USER_ONBOARDING = 'SET_NEW_USER_ONBOARDING'
export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES'
